import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" {...this.props}><path d="M14 12H2l6-8z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/sort.inline.svg